module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-fr\" viewBox=\"0 0 512 512\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#fff\" d=\"M0 0h512v512H0z\"/>\n    <path fill=\"#00267f\" d=\"M0 0h170.7v512H0z\"/>\n    <path fill=\"#f31830\" d=\"M341.3 0H512v512H341.3z\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./public/img/flags/1x1/fr.svg
// module id = OKyI
// module chunks = 5